import type { ColDef, ColTypeDef } from 'ag-grid-community';

import { WithGenericErrorCellBoundary } from '../CellRenderers/ErrorBoundaryCellRenderer';

export function useErrorBoundaryWrapper<T>(gridContext?: Record<string, string | undefined>) {
  const withGenericErrorCellBoundaryWrapper = (_key: string, { cellRenderer }: ColDef): any => {
    if (cellRenderer === undefined) {
      return undefined;
    }
    if (typeof cellRenderer === 'string') {
      return cellRenderer;
    }
    return WithGenericErrorCellBoundary(cellRenderer, gridContext);
  };

  return (colTypes?: { [key: string]: ColTypeDef<T> }) => {
    if (colTypes === undefined) {
      return undefined;
    }

    for (const key in colTypes) {
      colTypes[key].cellRenderer = withGenericErrorCellBoundaryWrapper(key, colTypes[key]);
    }
    return colTypes;
  };
}
